export const AUTH_SESSION_EXPIRED = 'dth:auth-session-expired';

export function notifyAuthSessionExpired() {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(AUTH_SESSION_EXPIRED));
  }
}
